import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";
export const PROJECT = "project";

export const PROJECT_STORE = "project";

export default {
  namespaced: true,

  state,

  actions,

  getters,

  mutations,
};
